<template>
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-3xl font-bold text-center mb-6">Carrier Services</h1>
    <p class="text-center mb-8 text-gray-600 max-w-3xl mx-auto">
      Use the tools below to make a payment on your policy or file a claim with your insurance carrier.
      Simply search for your carrier and click the appropriate button.
    </p>
    
    <CarrierServices />
  </div>
</template>

<script>
import CarrierServices from './common/CarrierServices.vue';

export default {
  name: 'CarrierServicesPage',
  components: {
    CarrierServices
  }
};
</script> 